import React from 'react'

import Layout from '../components/layout'
import Img from '../components/img'
import FeatureHeadingSection from '../components/feature-heading-section'

import flakyTestManagementIcon from '../images/features/flaky-test-management-icon.svg'

const FlakyTestManagement = () => {
  return (
    <Layout className="flaky-test-management">
      <FeatureHeadingSection iconSrc={flakyTestManagementIcon}>
        Flaky Test Management
      </FeatureHeadingSection>

      <section className="feature centered">
        <div className="description">
          <h2>Managing Flakiness</h2>

          <p>
            A centralized table makes it easy for teams to stay on top of
            flakiness. Every developer is empowered to identify, triage, and
            begin fixing flaky tests.
          </p>
        </div>

        <div className="illustration">
          <Img id="flakyTestManagementManaging" />
        </div>
      </section>

      <section className="feature centered decorated">
        <div className="description">
          <h2>Fixing Flakiness</h2>

          <p>
            A built-in workflow for fixing flaky tests ensures there's no
            confusion as to which test was addressed by who, when, and how it
            was resolved.
          </p>
        </div>

        <div className="illustration">
          <Img id="flakyTestManagementFixing" />
        </div>
      </section>

      <section className="feature centered decorated">
        <div className="description">
          <h2>Insights at Your Fingertips</h2>

          <p>
            A high-level overview of every commit and every test for your
            service lets you spot trends and patterns into problematic tests.
          </p>
        </div>

        <div className="illustration">
          <Img id="flakyTestManagementInsights" />
        </div>
      </section>
    </Layout>
  )
}

export default FlakyTestManagement
